<style>
#facility {
    /*background-color: #232633;*/
  z-index: 9;
}
#facility .card, #facility .card-body {
  /*background-color: #232633;/*
  border-radius: 0;
}
#facility .theme--dark.v-list{
 /* background-color: #232633 !important;*/
}
[dir] #facility .theme--dark.v-tabs > .v-tabs-bar{
 /* background-color: #232633 !important;*/
  /*color: #fff;*/
}
.v-tab{
  letter-spacing: normal !important;
}
#facility .v-list-item{
  padding: 5px;
  box-shadow: 0 1px 0px rgb(253, 253, 253), 0 1px 0px rgba(0, 0, 0, 0);
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 7px;

}
#facility .v-list-item__icon{
  margin: 16px 10px;
}
</style>
<template>
  <section
    id="facility"
    style="width: 100vw;
            height: 100vh;
            padding: 0px !important;
            margin: 0px !important;
            top: 0px !important;
            left: 0px !important;
            position: absolute;"
  >
    <b-card>
      <b-card-body>
        <v-tabs
          dark
          right
        >
          <v-tab>تنظیمات</v-tab>
          <v-tab v-if="usertype === 2">مدیریت</v-tab>

          <v-tab-item
            :key="1"
          >
            <v-list dark>
              <v-list-item-group
                v-model="selectedItem"
                color="primary"
              >
                <v-list-item
                  v-for="(item, i) in itemsUser"
                  :key="i"
                  @click="tabClick(item.rout)"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon" />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text" />
                  </v-list-item-content>
                </v-list-item>

              </v-list-item-group>
            </v-list>

          </v-tab-item>
          <v-tab-item
            v-if="usertype == 2"
            :key="2"
          >
            <v-list dark>
              <v-list-item-group
                v-model="selectedItem2"
                color="primary"
              >
                <v-list-item
                  v-for="(item, i) in itemsManager"
                  :key="i"
                  @click="tabClick(item.rout)"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon" />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text" />
                  </v-list-item-content>
                </v-list-item>

              </v-list-item-group>
            </v-list>

          </v-tab-item>
        </v-tabs>
      </b-card-body>
    </b-card>

  </section>

</template>
<script>
import Vue from 'vue'
import {
  BCard, BCardBody, BButton, BTab,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import Device from '@/models/device'
import DeviceService from '@/services/device.service'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BTab,
    BCard,
    BCardBody,
    BButton,
  },
  data: () => ({
    usertype: getUserData().type,
    tab: null,
    selectedItem: -1,
    selectedItem2: -1,
    itemsUser: [
      { text: 'تمدید اشتراک', icon: 'mdi-credit-card', rout: 'subscription-renew' },
      { text: 'کیف پول', icon: 'mdi-wallet', rout: 'payment-wallet' },
      { text: 'تراکنش‌های من', icon: 'mdi-history', rout: 'payment-transactions' },
      { text: 'سوالات متداول', icon: 'mdi-apps', rout: 'faq' },
      { text: 'خروج از حساب کاربری', icon: 'mdi-logout', rout: 'logout' },
    ],
    itemsManager: [
      { text: 'مشتریان', icon: 'mdi-account', rout: 'admin-customer-list' },
      { text: 'نماینده ها', icon: 'mdi-message-bulleted', rout: 'admin-agent-list' },
      { text: 'دستگاه ها', icon: 'mdi-shopping', rout: 'admin-device-all' },
      { text: 'مدل ها', icon: 'mdi-apps', rout: 'admin-model-list' },
      { text: 'مدیران', icon: 'mdi-apps', rout: 'admin-manager-list' },
      { text: 'سرورها', icon: 'mdi-apps', rout: 'admin-server-list' },
      { text: 'تنظیمات درگاه پرداخت', icon: 'mdi-credit-card-settings', rout: 'admin-payment-config' },
      { text: 'تراکنش‌ها', icon: 'mdi-cash-multiple', rout: 'admin-payment-transactions' },
      { text: 'کیف پول مشتریان', icon: 'mdi-wallet', rout: 'admin-payment-wallets' },
    ],
  }),
  computed: {
  },
  async created() {

  },
  mutations: {
    deleteItem(state, payload) {
      state.items.splice(payload, 1)
    },
  },
  methods: {
    tabClick(rout) {
      if (rout === 'logout') {
        // eslint-disable-next-line no-restricted-globals,no-alert
        if (confirm('آیا مطمئن هستید؟')) {
          this.$store.dispatch('auth/logout')
          this.$router.push('/login')
        }
      } else if (rout === 'inbox' || rout === 'shop' || rout === 'faq') {
        if (Vue.prototype.$productionPlatform !== 'web') {
          window.location.href = 'http://127.0.0.1:3232/QXNative/?action=launchBrowser-openHomePage'
        } else {
          window.location.href = 'https://4-rah.com/'
        }
      } else {
        router.push({ name: rout }).catch(err => {})
      }
    },
    addClick() {
      router.push({ name: 'admin-device-add' })
    },
    onCancel() {
      this.show = false
      this.$router.push({ name: 'model-list' })
    },
  },
}
</script>
